import { Message, message } from 'antd';
import { useEffect, useState, useCallback } from 'react';
import DashboardPresentation from '../../presentation/dashboardPresentation/index.js';
import { useHomeService } from '../../service/home.services.jsx';
import { gql, useMutation, useQuery, useApolloClient } from '@apollo/client';
import { REVERSE_MAPING_BADGE_TYPE, ICON_COMPLETE_MAP } from 'src/RnRCommonComponent/CoreBadge/rewardsConstants';

import useGetFeedList from '../../container/hooks/useGetFeedList.js';

const CREATE_BADGE_ASSIGNMENT = gql`mutation CreateBadgeAssignment($input: CreateBadgeAssignmentInput!) {
	 createBadgeAssignment(input: $input) {
	   badgeId
	   userId
	   awardedBy
	   awardedByUser {
			id
			firstName
			lastName
			avatar {
				bucket
				key
				region
			}
			departmentId
			userGroupId
			subCompanyId
	   }
	   companyId
	   createdAt
	   updatedAt
	   approvalStatus
	   additionalRecipients
	   additionalRecipientsUsers {
			id
			firstName
			lastName
			departmentId
		  	subCompanyId
			userGroupId
	   }
	   points
	   user {
          id
          firstName
          lastName
		  departmentId
		  subCompanyId
		  userGroupId
          avatar {
		  	key
			bucket
			region
		  }
       }
	   badge {
	     id
	     name
	     description
	     points
	   }
	 }
}`;

const QUERY_BADGE_ASSIGNMENTS = gql`
  query QueryBadgeAssignments($companyId: ID!, $nextToken: String) {
    queryBadgeAssignments(
      companyId: $companyId
      nextToken: $nextToken
    ) {
      items {
        approvalStatus
		additionalRecipients
		additionalRecipientsUsers {
			id
			firstName
			lastName
			departmentId
		  	subCompanyId
			userGroupId
		}
        awardedBy
		awardedByUser {
			id
			firstName
			lastName
			avatar {
				bucket
				key
				region
			}
			departmentId
			userGroupId
			subCompanyId
		}
        id
        badgeId
        badge {
            id
            name
			badgeType {
				code
			}
			badgeTypeId
			color
			description
			gradientColor
			iconId
			icon {
				code
			}
			image
			label
        }
		comments
		content {
			message
			gifURL
		}
        rewardBonus
		points
        companyId
		createdAt
		totalClaps
		hasClappedUsers {
	     id
		 firstName
		 lastName
	    }
        userId
        user {
          id
          firstName
          lastName
		  departmentId
		  subCompanyId
		  userGroupId
          avatar {
		  	key
			bucket
			region
		  }
        }
      }
      nextToken
    }
  }
`;

const UPDATE_BADGE_ASSIGNMENT = gql`mutation UpdateBadgeAssignment($input: UpdateBadgeAssignmentInput!) {
	 updateBadgeAssignment(input: $input) {
	   id
	   badgeId
	   badge {
            id
            name
			badgeType {
				code
			}
			badgeTypeId
			color
			description
			gradientColor
			iconId
			icon {
				code
			}
			image
			label
        }
	   awardedBy
	   awardedByUser {
			id
			firstName
			lastName
			avatar {
				bucket
				key
				region
			}
			departmentId
			userGroupId
			subCompanyId
	   }
	   companyId
	   createdAt
	   approvalStatus
	   additionalRecipients
	   additionalRecipientsUsers {
			id
			firstName
			lastName
			departmentId
		  	subCompanyId
		}
	   rewardBonus
	   points
	   comments
	   totalClaps
	   hasClappedUsers {
	     id
		 firstName
		 lastName
	   }
	   content {
	     message
		 gifURL
	   }
	   userId
       user {
          id
          firstName
          lastName
		  departmentId
		  subCompanyId
          avatar {
		  	key
			bucket
			region
		  }
       }
	 }
}`;

const ADD_REMOVE_CLAP = gql`mutation AddRemoveClap($badgeAssignmentId: ID!, $userId: ID!) {
	addRemoveClap(
		badgeAssignmentId: $badgeAssignmentId
		userId: $userId
	) {
	   id
	   badgeId
	   badge {
            id
            name
			badgeType {
				code
			}
			badgeTypeId
			color
			description
			gradientColor
			iconId
			icon {
				code
			}
			image
			label
        }
	   awardedBy
	   awardedByUser {
			id
			firstName
			lastName
			avatar {
				bucket
				key
				region
			}
			departmentId
			userGroupId
			subCompanyId
	   }
	   companyId
	   createdAt
	   approvalStatus
	   additionalRecipients
	   additionalRecipientsUsers {
			id
			firstName
			lastName
			departmentId
		  	subCompanyId
	   }
	   rewardBonus
	   points
	   comments
	   totalClaps
	   hasClappedUsers {
	     id
		 firstName
		 lastName
	   }
	   content {
	     message
		 gifURL
	   }
	   userId
       user {
          id
          firstName
          lastName
		  departmentId
		  subCompanyId
          avatar {
		  	key
			bucket
			region
		  }
       }
	 }
}`;

const DashboardContainer = (props) => {
	const currentUser = props?.currentUser || {};
	const [isOpenRewardModel, setIsOpenRewardModel] = useState(false);
	const [sendrewardObject, setSendRewardObject] = useState({});
	const [isShoutOutSend, setIsShoutOutSend] = useState(false);
	const [isEmployeeSelected, setIsEmployeeSelected] = useState(false);
	const [additionalRecipients, setAdditionalRecipients] = useState([]);
	const [ createBadgeAssignment, { data, loading, error }] = useMutation(CREATE_BADGE_ASSIGNMENT, {
		variables: {
			input: {
				itemType: 'BadgeAssignment',
	 			badgeId: sendrewardObject?.selectedBadge?.id,
	 			companyId: currentUser?.company?.id,
	 			userId: sendrewardObject?.employeeDetail,
	 			awardedBy: currentUser?.id,
	 			managerAssigned: false,
	 			additionalRecipients: additionalRecipients,
	 			content: {
	 				message: sendrewardObject?.content?.message?.trim(),
	 				gifURL: sendrewardObject?.content?.gifURL,
	 			},
			}
		}
	});

	const [updateBadgeAssignment] = useMutation(UPDATE_BADGE_ASSIGNMENT);
	const [addRemoveClap] = useMutation(ADD_REMOVE_CLAP);
	const [pageLimit] = useState(10);

	const { data: badgeAssignmentsData, loading: badgeAssignmentsLoading, error: badgeAssignmentsError, refetch: refetchBadgeAssignments } = useQuery(QUERY_BADGE_ASSIGNMENTS, {
		variables: {
			companyId: currentUser?.companyId
		},
		skip: !currentUser?.companyId,
		fetchPolicy: 'cache-and-network',
		onCompleted: async (data) => {
			let allAssignments = [...data.queryBadgeAssignments.items];
			let nextToken = data.queryBadgeAssignments.nextToken;

			while (nextToken) {
				try {
					const result = await apolloClient.query({
						query: QUERY_BADGE_ASSIGNMENTS,
						variables: {
							companyId: currentUser?.companyId,
							nextToken: nextToken
						}
					});
					allAssignments = [...allAssignments, ...result.data.queryBadgeAssignments.items];
					nextToken = result.data.queryBadgeAssignments.nextToken;
				} catch (error) {
					console.error('Error fetching additional badge assignments:', error);
					break;
				}
			}

			setAllBadgeAssignments(allAssignments);
			calculateLeaderboards(allAssignments);
			
			const feedRecords = transformBadgeAssignmentsToFeedRecords(allAssignments);
			setGraphqlFeedData(feedRecords);
			setGraphqlFeedLoading(false);
		}
	});

	useEffect(() => {
		if (currentUser?.companyId && refetchBadgeAssignments) {
			refetchBadgeAssignments();
		}
	}, [currentUser?.companyId, refetchBadgeAssignments]);

	const [isDataRefresh, setIsDataReferash] = useState(false);
	const [graphqlFeedData, setGraphqlFeedData] = useState([]);
	const [graphqlFeedLoading, setGraphqlFeedLoading] = useState(true);
	
	const topFeedData = [...graphqlFeedData]
		.sort((a, b) => {
			const aEngagement = (a.totalClaps || 0) + (a.comments?.length || 0);
			const bEngagement = (b.totalClaps || 0) + (b.comments?.length || 0);
			return bEngagement - aEngagement;
		});
	
	const teamFeedData = graphqlFeedData.filter(item =>
		item.awardedByUser?.departmentId === currentUser?.departmentId
	);
	const [allBadgeAssignments, setAllBadgeAssignments] = useState([]);
	const [leaderboardData, setLeaderboardData] = useState({
		all: [],
		department: [],
		subcompany: []
	});

	const homeAPIService = useHomeService();
	const apolloClient = useApolloClient();

	const calculateLeaderboards = useCallback((badgeAssignments) => {
		const userPointsMap = new Map();

		if (badgeAssignments && badgeAssignments.length > 0) {
			badgeAssignments.forEach(assignment => {
				if (assignment.user?.id && assignment.points) {
					const userId = assignment.user.id;
					const currentPoints = userPointsMap.get(userId) || {
						user: assignment.user,
						totalPoints: 0
					};
					
					currentPoints.totalPoints += assignment.points;
					userPointsMap.set(userId, currentPoints);
				}
			});
		}

		if (currentUser?.id && !userPointsMap.has(currentUser.id)) {
			userPointsMap.set(currentUser.id, {
				user: {
					id: currentUser.id,
					firstName: currentUser.firstName,
					lastName: currentUser.lastName,
					departmentId: currentUser.departmentId,
					subCompanyId: currentUser.subCompanyId
				},
				totalPoints: 0
			});
		}

		const allUsers = Array.from(userPointsMap.values())
			.sort((a, b) => b.totalPoints - a.totalPoints)
			.map((item, index) => ({
				rank: index + 1,
				firstName: item.user.firstName,
				lastName: item.user.lastName,
				points: item.totalPoints,
				isCurrent: item.user.id === currentUser?.id,
				userId: item.user.id,
				departmentId: item.user.departmentId,
				subCompanyId: item.user.subCompanyId
			}));

		const departmentUsers = allUsers
			.filter(user => user.departmentId === currentUser?.departmentId)
			.map((user, index) => ({ ...user, rank: index + 1 }));

		const subcompanyUsers = allUsers
			.filter(user => user.subCompanyId === currentUser?.subCompanyId)
			.map((user, index) => ({ ...user, rank: index + 1 }));
		const getLeaderboardWithCurrentUser = (users) => {
			if (users.length === 0) return [];
			
			const currentUserIndex = users.findIndex(user => user.isCurrent);
			
			if (currentUserIndex === -1 || currentUserIndex < 10) {
				return users.slice(0, 10);
			}
			
			const top10 = users.slice(0, 10);
			const currentUserEntry = users[currentUserIndex];
			return [...top10, currentUserEntry];
		};

		setLeaderboardData({
			all: getLeaderboardWithCurrentUser(allUsers),
			department: getLeaderboardWithCurrentUser(departmentUsers),
			subcompany: getLeaderboardWithCurrentUser(subcompanyUsers)
		});
	}, [currentUser?.id, currentUser?.departmentId, currentUser?.subCompanyId, currentUser?.firstName, currentUser?.lastName]);

	const transformBadgeAssignmentsToFeedRecords = (badgeAssignments) => {
		if (!badgeAssignments || badgeAssignments.length === 0) {
			return [];
		}

		const transformed = [...badgeAssignments]
			.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
			.map((assignment, index) => {
				
				let additionalRecipientsUsers = [];
				let comments = [];
				
				try {
					additionalRecipientsUsers = assignment.additionalRecipientsUsers
						? assignment.additionalRecipientsUsers
						: [];
				} catch (e) {
					console.warn('Failed to parse additionalRecipients:', assignment.additionalRecipientsUsers);
					additionalRecipientsUsers = [];
				}

				try {
					comments = assignment.comments
						? JSON.parse(assignment.comments)
						: [];
				} catch (e) {
					console.warn('Failed to parse comments:', assignment.comments);
					comments = [];
				}

				const recipients = additionalRecipientsUsers.map(user => {
					return {
						id: user.id,
						firstName: user.firstName,
						lastName: user.lastName,
					};
				});
				recipients.unshift({
					id: assignment.user?.id,
					firstName: assignment.user?.firstName,
					lastName: assignment.user?.lastName,
					avatar: assignment.user?.avatar
				});

				const badgeTypeCode = assignment.badge?.badgeTypeId
					? REVERSE_MAPING_BADGE_TYPE[assignment.badge.badgeTypeId]
					: null;

				const iconData = assignment.badge?.iconId
					? ICON_COMPLETE_MAP.find(icon => icon.id === assignment.badge.iconId)
					: null;

				const transformedItem = {
					id: assignment.id,
					content: {
						message: assignment.content?.message || '',
						gifURL: assignment.content?.gifURL || null
					},
					badge: {
						id: assignment.badge?.id,
						name: assignment.badge?.name,
						description: assignment.badge?.description,
						badgeType: badgeTypeCode ? { code: badgeTypeCode } : assignment.badge?.badgeType,
						badgeTypeId: assignment.badge?.badgeTypeId,
						color: assignment.badge?.color,
						gradientColor: assignment.badge?.gradientColor,
						iconId: assignment.badge?.iconId,
						icon: iconData ? { code: iconData.code } : assignment.badge?.icon,
						image: assignment.badge?.image,
						label: assignment.badge?.label
					},
					employee: {
						id: assignment.user?.id,
						firstName: assignment.user?.firstName,
						lastName: assignment.user?.lastName,
						avatar: assignment.user?.avatar
					},
					employees: recipients,
					additionalRecipients: recipients,
					awardedByUser: assignment.awardedByUser,
					hasClapped: assignment.hasClappedUsers?.some(user => user.id === currentUser?.id) || false,
					totalClaps: assignment.totalClaps || 0,
					hasClappedUsers: assignment.hasClappedUsers || [],
					comments: comments,
					createdAt: assignment.createdAt,
					approvalStatus: assignment.approvalStatus,
					points: assignment.points,
					rewardBonus: assignment.rewardBonus,
					additionalRecipientIds: assignment.additionalRecipients
				};

				return transformedItem;
			});

		return transformed;
	};

	const handleReplySubmit = async (badgeAssignmentId, replyText) => {
		try {
			const currentAssignment = graphqlFeedData.find(item => item.id === badgeAssignmentId);
			if (!currentAssignment) {
				throw new Error('Badge assignment not found');
			}

			const currentComments = currentAssignment.comments || [];
			
			const newComment = {
				userId: currentUser?.id,
				firstName: currentUser?.firstName,
				lastName: currentUser?.lastName,
				avatarKey: currentUser?.avatar?.key || null,
				message: replyText,
				createdAt: new Date().toISOString()
			};

			const updatedComments = [...currentComments, newComment];

			const commentsJson = JSON.stringify(updatedComments);

			const { data } = await updateBadgeAssignment({
				variables: {
					input: {
						id: badgeAssignmentId,
						companyId: currentUser?.company?.id,
						comments: commentsJson
					}
				}
			});

			if (data?.updateBadgeAssignment) {
				setGraphqlFeedData(prevData =>
					prevData.map(item => {
						if (item.id === badgeAssignmentId) {
							return {
								...item,
								comments: updatedComments
							};
						}
						return item;
					})
				);

				message.success('Reply added successfully');
				return true;
			}
		} catch (error) {
			console.error('Error submitting reply:', error);
			message.error('Failed to add reply. Please try again.');
			return false;
		}
	};

	const handleClapClick = async (badgeAssignmentId) => {
		try {
			const { data } = await addRemoveClap({
				variables: {
					badgeAssignmentId: badgeAssignmentId,
					userId: currentUser?.id
				}
			});

			if (data?.addRemoveClap) {
				setGraphqlFeedData(prevData =>
					prevData.map(item => {
						if (item.id === badgeAssignmentId) {
							return {
								...item,
								totalClaps: data.addRemoveClap.totalClaps,
								hasClappedUsers: data.addRemoveClap.hasClappedUsers,
								hasClapped: data.addRemoveClap.hasClappedUsers?.some(user => user.id === currentUser?.id) || false
							};
						}
						return item;
					})
				);

				return true;
			}
		} catch (error) {
			console.error('Error toggling clap:', error);
			message.error('Failed to update clap. Please try again.');
			return false;
		}
	};

	const {
		getFeedData,
		isLoadMoreCalled,
		hasMoreData,
		feedListData,
		setFeedListData,
		isFeedLoading,
		setIsFeedLoading,
		currentPage,
		setCurrentPage,
	} = useGetFeedList({ myBranch: false });

	const {
		getFeedData: getMyBranchFeedData,
		isLoadMoreCalled: isMyBranchLoadMoreCalled,
		hasMoreData: myBranchHasMoreData,
		feedListData: myBranchFeedListData,
		setFeedListData: setMyBranchFeedListData,
		isFeedLoading: isMyBranchFeedLoading,
		setIsFeedLoading: setIsMyBranchFeedLoading,
		currentPage: myBranchcurrentPage,
		setCurrentPage: setMyBranchCurrentPage,
	} = useGetFeedList({ myBranch: true });

	const {
		getFeedData: getTopFeedData,
		isLoadMoreCalled: isTopLoadMoreCalled,
		hasMoreData: topHasMoreData,
		feedListData: topFeedListData,
		setFeedListData: setTopFeedListData,
		isFeedLoading: isTopFeedLoading,
		setIsFeedLoading: setIsTopFeedLoading,
		currentPage: topcurrentPage,
		setCurrentPage: setTopCurrentPage,
	} = useGetFeedList({ top: true });

	const fetchInitialData = (isNewPost = false) => {
		setIsFeedLoading(true);
		setIsMyBranchFeedLoading(true);
		setIsTopFeedLoading(true);
		setCurrentPage(1);
		getFeedData(1, pageLimit, isNewPost);
		getMyBranchFeedData(1, pageLimit, isNewPost);
		getTopFeedData(1, pageLimit, isNewPost);
		
		if (isNewPost && refetchBadgeAssignments) {
			refetchBadgeAssignments();
		}
	};

	useEffect(() => {
		getTemplateData();
		fetchInitialData();
	}, []);

	const fetchMoreData = () => {
		setCurrentPage(currentPage + 1);
		getFeedData(currentPage + 1, pageLimit);
	};

	const fetchMyBranchMoreData = () => {
		setMyBranchCurrentPage && setMyBranchCurrentPage(myBranchcurrentPage + 1);
		getMyBranchFeedData(myBranchcurrentPage + 1, pageLimit);
	};

	const fetchTopMoreData = () => {
		setTopCurrentPage && setTopCurrentPage(topcurrentPage + 1);
		getTopFeedData(topcurrentPage + 1, pageLimit);
	};

	const getTemplateData = () => {
		homeAPIService
			.getRecentActivityProperties({ property: 'template' })
			.then((response) => {
				if (response.code === 200) {
					let data = response?.data;
					let recentActivityTemplateData = JSON.stringify(data);
					localStorage.setItem('template', recentActivityTemplateData);
				}
			})
			.catch((error) => {
				console.error('Error fetching template data:', error);
			});
	};

	const handleSendShoutout = async () => {
		if (
			sendrewardObject?.employeeDetail === undefined ||
			sendrewardObject?.employeeDetail === null
		) {
			setIsEmployeeSelected(true);
			return;
		}
		if (
			(!sendrewardObject?.content ||
				sendrewardObject?.content?.message?.trim().length === 0) &&
			!sendrewardObject?.rewardtype
		) {
			Message.error('Please add recognition or message to assign.');
			return;
		}
		
		const sendShouOut = {
			badgeId: sendrewardObject?.rewardtype,
			employeeId: sendrewardObject?.employeeDetail,
			content: sendrewardObject?.content ? JSON.stringify(sendrewardObject?.content) : '',
			companyId: props?.company?.id,
			clapCounts: 0,
			awardedBy: props?.currentUser?.id,
		};
		
		const isPreApproved = sendrewardObject?.selectedBadge?.isPreApproved;
		const requireAdminApproval = currentUser?.company?.recognitionSettings?.requireAdminApproval;
		
		try {
			setIsShoutOutSend(true);
			
			const response = await homeAPIService.createBadgeAssignment(sendShouOut);
			
			if (response.code === 201) {
				console.log("BADGEASSIGNRESP", response);
				
				await createBadgeAssignment({
					variables: {
						input: {
							itemType: 'BadgeAssignment',
							id: response.data.id,
							assignmentId: response.data.id,
							badgeId: sendrewardObject?.selectedBadge?.id,
							companyId: currentUser?.company?.id,
							userId: sendrewardObject?.employeeDetail,
							awardedBy: currentUser?.id,
							managerAssigned: false,
							points: sendrewardObject?.selectedBadge?.points,
							rewardBonus: sendrewardObject?.selectedBadge?.rewardBonus,
							additionalRecipients: additionalRecipients,
							approvalStatus: (!isPreApproved || requireAdminApproval) ? 'Pending' : 'Approved',
							content: {
								message: sendrewardObject?.content?.message?.trim(),
								gifURL: sendrewardObject?.content?.gifURL,
							},
						}
					}
				});
				
				if (refetchBadgeAssignments) {
					const result = await refetchBadgeAssignments();
					
					if (result?.data?.queryBadgeAssignments?.items) {
						let allAssignments = [...result.data.queryBadgeAssignments.items];
						let nextToken = result.data.queryBadgeAssignments.nextToken;

						while (nextToken) {
							try {
								const paginatedResult = await apolloClient.query({
									query: QUERY_BADGE_ASSIGNMENTS,
									variables: {
										companyId: currentUser?.companyId,
										nextToken: nextToken
									}
								});
								allAssignments = [...allAssignments, ...paginatedResult.data.queryBadgeAssignments.items];
								nextToken = paginatedResult.data.queryBadgeAssignments.nextToken;
							} catch (error) {
								console.error('Error fetching additional badge assignments:', error);
								break;
							}
						}

						setAllBadgeAssignments(allAssignments);
						calculateLeaderboards(allAssignments);
						
						const feedRecords = transformBadgeAssignmentsToFeedRecords(allAssignments);
						setGraphqlFeedData(feedRecords);
						setGraphqlFeedLoading(false);
					}
				}
				
				setIsShoutOutSend(false);
				Message.success(response?.message);
				setSendRewardObject(null);
				setAdditionalRecipients([]);
				fetchInitialData(true);
				setIsDataReferash(true);
			} else {
				setIsShoutOutSend(false);
				setSendRewardObject(null);
			}
		} catch (error) {
			console.error('Error in handleSendShoutout:', error);
			setIsShoutOutSend(false);
			message.error('Failed to create recognition! Try again later.');
		}
	};

	return (
		<div>
			<DashboardPresentation
				sendrewardObject={sendrewardObject}
				setSendRewardObject={setSendRewardObject}
				isOpenRewardModel={isOpenRewardModel}
				setIsOpenRewardModel={setIsOpenRewardModel}
				isShoutOutSend={isShoutOutSend}
				setIsShoutOutSend={setIsShoutOutSend}
				handleSendShoutout={handleSendShoutout}
				isEmployeeSelected={isEmployeeSelected}
				setIsEMployeeSelected={setIsEmployeeSelected}
				additionalRecipients={additionalRecipients}
				setAdditionalRecipients={setAdditionalRecipients}
				feedListData={feedListData}
				isFeedLoading={isFeedLoading}
				setFeedListData={setFeedListData}
				fetchMoreData={fetchMoreData}
				isLoadMoreCalled={isLoadMoreCalled}
				hasMoreData={hasMoreData}
				getTemplateData={getTemplateData}
				isDataRefresh={isDataRefresh}
				setIsDataReferash={setIsDataReferash}
				isMyBranchLoadMoreCalled={isMyBranchLoadMoreCalled}
				myBranchHasMoreData={myBranchHasMoreData}
				myBranchFeedListData={myBranchFeedListData}
				isMyBranchFeedLoading={isMyBranchFeedLoading}
				setMyBranchFeedListData={setMyBranchFeedListData}
				fetchMyBranchMoreData={fetchMyBranchMoreData}
				isTopLoadMoreCalled={isTopLoadMoreCalled}
				topHasMoreData={topHasMoreData}
				topFeedListData={topFeedListData}
				isTopFeedLoading={isTopFeedLoading}
				setTopFeedListData={setTopFeedListData}
				fetchTopMoreData={fetchTopMoreData}
				graphqlFeedData={graphqlFeedData}
				topFeedData={topFeedData}
				teamFeedData={teamFeedData}
				graphqlFeedLoading={graphqlFeedLoading}
				handleReplySubmit={handleReplySubmit}
				handleClapClick={handleClapClick}
				leaderboardData={leaderboardData}
			/>
		</div>
	);
};
export default DashboardContainer;
